export default {
  methods: {
    async setupTracker() {
      if(this.isLightHouse) return
      if(this.gtmId) {
        this.appendScript(this.gtmScript)
      }

      if(this.gaId) {
        await import(
          /* webpackChunkName: "autotrack" */
          /* webpackPrefetch: true */
          'autotrack'
        )
        this.appendScript(this.gaScript)
      }
    },
    appendScript(content) {
      $('head').append(content);
    }
  },
  computed: {
    isLightHouse() {
      if(navigator.userAgent.indexOf('Page Speed') > -1) return true
      if(navigator.userAgent.indexOf('Speed Insights') > -1) return true
      if(navigator.userAgent.indexOf('Chrome-Lighthouse') > -1) return true
      return false
    },
    gtmId() {
      if(!this.trackerConfig) return null
      return this.trackerConfig.gtm.id
    },
    gtmScript() {
      if(!this.trackerConfig) return null
      return `<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${this.trackerConfig.gtm.id}');</script>`
    },
    gaId() {
      if(!this.trackerConfig) return null
      return this.trackerConfig.ga.id
    },
    gaScript() {
      if(!this.trackerConfig) return null
      return `<script>(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
ga('create', '${this.trackerConfig.ga.id}', 'auto');

ga('require', 'ec');
ga('require', 'eventTracker');
ga('require', 'urlChangeTracker');

ga('send', 'pageview');</script>`
    },
    application() {
      return this.$store.getters['base/application']
    },
    trackerConfig() {
      if(!this.application) return null
      return this.application.tracker
    },
    siteName() {
      return this.$store.getters['base/siteName']
    },
    seo() {
      return this.$store.getters['base/seo']
    },
    language() {
      return this.$store.getters['locale/language']
    },
  },
}